import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Loader from "../common/Loader";
import { getSellerAccess } from "../../utils/getSellerRedirect";

const ProtectedRouteWithVerification = () => {
  const { user, loading } = useSelector((state) => state.auth);
  const accountStatus = useSelector((state) => state.seller.accountStatus.data);
  const navigate = useNavigate();
  const location = useLocation();

  const access = useMemo(() => {
    if (loading || !user) return { isAllowed: true }; // loading state handled below
    const { redirectTo, allowedRoutes } = getSellerAccess(user, accountStatus);
    const currentPath = location.pathname;
    // Check if the current path is allowed
    const isAllowed = allowedRoutes.some((path) => currentPath.startsWith(path));
    return { isAllowed, redirectTo };
  }, [loading, user, accountStatus, location.pathname]);

  useEffect(() => {
    if (!access.isAllowed) {
      navigate(access.redirectTo, { replace: true });
    }
  }, [access, navigate]);

  // Now safely return UI based on conditions
  if (loading || !user) return <Loader />;

  // If not allowed, show loader while navigating away
  if (!access.isAllowed) return <Loader />;

  return <Outlet />;
};

export default ProtectedRouteWithVerification;
